import styled from "styled-components";
import { colors } from "../../assets/styles";

export const Row = styled.div``;

export const Col = styled.div``;

export const InputLabel = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme ? colors.textColorBlackFive : colors.textColorBlackFor};
`;

export const InputError = styled.div``;
